<template>
  <section v-if="isNotEmptyNotices" class="notice">
    <div class="notice__container">
      <div class="notice__title subhead-bold">
        お知らせ
      </div>
      <a
        v-for="notice in notices"
        :key="notice.id"
        :href="`/announcements/${notice.id}`"
        class="tl-list tl-list__text chevron--forward--black"
      >
        <span class="notice--date">{{ notice.date }}</span>
        <span>{{ notice.title }}</span>
      </a>
    </div>
  </section>
</template>
<script>
import axios from 'axios'
import dayjs from 'dayjs'
export default {
  props: {
    target: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isNoticesLoading: false,
      notices: []
    }
  },
  computed: {
    isNotEmptyNotices() {
      return this.notices.length !== 0
    }
  },
  mounted() {
    this.getNotices()
  },
  methods: {
    async getNotices() {
      this.isNoticesLoading = true
      try {
        const res = await axios.get(
          `/api/v1/${this.target}/announcements/notices`
        )
        this.notices = res.data.data.map(notice => ({
          id: notice.attributes.id,
          title: notice.attributes.title,
          date: dayjs(notice.attributes.started_at).format('MM/DD')
        }))
        this.isNoticesLoading = false
      } catch (error) {
        // TODO: Rails 側でエラーが発生した際にフロント側でどのような処理をするかを検討し、ここに実装する
        this.isNoticesLoading = true
        if (
          !error.response ||
          !error.response.status ||
          !error.response.statusText
        ) {
          console.log(`Error :${error}`)
          return
        }
        const { status, statusText } = error.response
        console.log(`Error! HTTP Status: ${status} ${statusText}`)
        const errorMessage =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'システムエラーが発生しました。しばらく経ってから再度アクセスしてください'
        console.log(`Error message: ${errorMessage}`)
      }
    }
  }
}
</script>
